export default {
    title: 'Ordering into the car service',
    titleBinding: 'Binding ordering into the car service',
    titleInspector: 'Order return with inspector',

    licensePlate: 'Registration number',
    mileage: 'Odometer reading (in km)',
    mileageValidation: 'Please enter the odometer reading.',

    contactSectionLabel: 'Contact details',
    firstName: 'Name',
    firstNameValidation: 'Please enter your name.',
    lastName: 'Surname',
    lastNameValidation: 'Please enter your surname.',
    email: 'E-mail',
    emailValidation: 'Please enter your e-mail.',
    emailValidationFormat: 'The e-mail you entered does not have the required format.',
    phone: 'Telephone',
    phoneCountryCode: 'Country code',
    phoneSelectCountry: 'Select country',
    phoneNumberPlaceholder: 'Telephone number',
    phoneNumberExample: 'Example: ',
    phoneValidation: 'Please enter your phone number.',
    phoneValidationFormat: 'The phone number you entered does not have the required format.',

    servicingActionsSectionLabel: 'Required servicing actions',
    servicingActionSectionLabel: 'Required servicing action',
    servicingActionSectionInfo: 'Please select one or more options.',
    servicingActionSectionNote: 'This form is not intended for arranging repairs after a damage claim.<br />To schedule a repair after an insurance claim, please contact us at <a href="tel:+420296333666" class="phone-number-section-note">+420 296 333 666</a>.',
    servicingActionSectionValidation: 'Please select the required servicing action.',
    servicingActionServiceInspectionLabel: 'Servicing check',
    servicingActionServiceInspectionTooltip: 'Regular service work prescribed by the manufacturer with a fixed range of actions and used material. Information on the need of carrying out such servicing check is usually given on the vehicle\'s dashboard or in the vehicle documentation.',
    servicingActionRepairLabel: 'Common repairs',
    servicingActionRepairTooltip: 'Repair and replacement of parts subject to normal wear and tear - brakes, air conditioning disinfection, lighting repair, wiper replacement, etc.',
    servicingActionTechnicalInspectionLabel: 'Technical inspection',
    servicingActionTechnicalInspectionTooltip: 'Technical inspection and emission control - legal obligation',
    servicingActionTechnicalInspectionAdditional: 'Yes, I have necessary documents for the technical inspection - a large vehicle registration certificate and a small technical certificate for vehicle (vehicle registration certificate).',
    servicingActionCallingActionLabel: 'Recall',
    servicingActionCallingActionTooltip: 'Service work on the vehicle based on the notification from the vehicle manufacturer.',
    servicingActionServiceOilChangeLabel: 'Engine oil change',
    servicingActionServiceOilChangeTooltip: 'Regular service work prescribed by the manufacturer with a fixed range of actions and used material. Information on the need of carrying out such servicing check is usually given on the vehicle\'s dashboard (notification about oil change) or in the vehicle documentation.',
    servicingActionBreakdownLabel: 'Breakdown',
    servicingActionBreakdownTooltip: 'Vehicle is inoperable or in such a state when driving is possible with difficulties.',
    servicingActionOtherLabel: 'Other',
    servicingActionOtherTooltip: 'E.g. Installation of vehicle accessory.',

    servicingActionInputTextPlaceholder: 'Please describe specifically what you require.',
    servicingActionInputTextValidation: 'Please fill in this field.',
    servicingActionInputCheckboxValidation: 'Please check this value.',

    supplementaryServicesSectionLabel: 'Supplementary services',
    supplementaryServicesNotAgreed: 'service is not agreed',
    supplementaryServicesPickUpLabel: 'Pick-up',
    supplementaryServicesPickUpStreetLabel: 'Address - street and street number',
    supplementaryServicesPickUpStreetValidation: 'Please fill in the street and street number.',
    supplementaryServicesPickUpTownLabel: 'Address - city',
    supplementaryServicesPickUpTownValidation: 'Please fill in the city.',
    supplementaryServicesPickUpZipLabel: 'Postal code',
    supplementaryServicesPickUpZipValidation: 'Please fill in the postal code.',
    supplementaryServicesPickUpAddressNotFound: 'The entered address was not found.',
    supplementaryServicesReplacementCarLabel: 'Replacement vehicle',
    supplementaryServicesReplacementCarAdditional: 'I have driving licence only for vehicles with automatic transmission.',
    supplementaryServicesCarWashLabel: 'Car wash - exterior',

    selectionDateSectionLabel: 'Selection of date',
    selectionDateSectionValidation: 'Please select the date.',
    selectionDateSectionSelectedSlotFirst: 'The selected slot',
    selectionDateSectionSelectedSlotSecond: 'is also reserved',
    selectionDateSectionTimeLabel: 'Selection of time',
    selectionDateSectionTimeBrought: 'Time when the vehicle will be brought to the service',
    selectionDateSectionTimePickUp: 'Time when the vehicle will be picked up',
    selectionDateSectionTimeValidation: 'Please select a time.',
    selectionDateSectionAlreadyReserved: 'This date has already been reserved by another user. Please select a different date.',

    termSectionPickupLabel: 'What dates would suit you for the pick-up',
    termSectionServiceLabel: 'What dates would suit you for the servicing works',
    termSectionPreferredDateDescription: 'Please fill in the dates in three different days',
    termSectionPeriodDescription: 'Fill in the dates in the period from - to',
    termSectionPreferredDatesLabel: 'Preferred date',
    termSectionPreferredDatesValidation: 'Please select the date and time.',
    termSectionPeriodLabel: 'Period from - to',
    termSectionPeriodValidation: 'Please select the period from - to.',
    termSectionPeriodCondition: 'Please select a period longer than one day.',
    termSectionTimeLabel: 'Time',
    termSectionTimeValidation: 'Please select a time.',

    serviceSupplierLocation: 'In case the selected service does not have available slots in the chosen timeframes, I agree to proceed with booking at another service in the same location.',
    serviceSupplierLocationValidation: 'Please select a value.',
    securityInfoFirst: 'Drivalia is committed to protecting and securing the personal data that it collects and processes. More information on the conditions of personal data processing can be found in',
    securityInfoLink: 'https://www.drivalia.cz/en/privacy-statement/',
    securityInfoSecond: 'privacy statement',
    mandatoryInfoFirst: 'Items marked with',
    mandatoryInfoSecond: 'are mandatory.',

    submitFormButton: 'Submit form',
    successFormSubmit: 'Dear client, your request has been successfully submitted. We will send you a text message confirming the date of ordered servicing of your car.',
    successInspectionFormSubmit: 'Dear client, your request for the vehicle return with an inspector has been successfully submitted.',
    warningFormSubmit: 'Failed to submit the form, please check the values filled in.',
    conflictFormSubmit: 'Failed to submit the form. There is already an active order for this vehicle.',
    errorFormSubmit: 'Unfortunately, your request cannot be sent through the form. Please contact us by phone on +420 296 333 666, extension 3.'
}
